export const FormPageFields = [
  'custom_text',
  'custom_divider',
  'custom_reference',
  'custom_formula',
  'custom_google_file',
  'custom_embed',
  'custom_linked_field_display',
  'custom_spacer',
  'custom_gpt'

] as const;

export type FormPageFieldType = typeof FormPageFields[number];

export type FormPageMode = typeof FormPageModes[number];

export type FormPageRecordMode = typeof FormPageRecordModes[number];



export const FormPageFieldDetails: {
  [key in FormPageFieldType]: {
    name: string;
    type: string;
  };
} = {
  custom_text: {
    name: 'Text',
    type: 'string',
  },
  custom_divider: {
    name: 'Divider',
    type: 'string',
  },
  custom_reference: {
    name: 'Linked Set',
    type: 'object',
  },
  custom_formula: {
    name: 'Formula',
    type: 'string',
  },
  custom_google_file: {
    name: 'Google File',
    type:'string'
  },
  custom_embed: {
    name: 'Embed/Iframe',
    type:'string'
  },
  custom_linked_field_display: {
    name: 'Linked Field Display',
    type: 'string'
  },
  custom_spacer: {
    name: 'Spacing',
    type:'string'
  },
  custom_gpt: {
    name: 'ChatGPT',
    type:'string'
  },
};

export const FormPageAirtableFieldTypes = <const>['text', 'number'];

export const FormPageModes = ['single_record', 'webhook'] as const;

export const FormPageRecordModes = ['update', 'create', 'update_or_create'] as const;
